import { styled } from '@mui/material/styles';
import { Typography } from '@raisin/components-lib';
export const Disclaimer = styled(Typography)(({ theme }) => ({
    padding: theme.spacing(6, 0),
    color: theme.palette.grey700.main,
    borderTop: `1px solid ${theme.palette.grey200.main}`,
    '& p:last-of-type': {
        marginBottom: 0,
    },
    '& p:first-of-type': {
        marginTop: 0,
    },
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(4, 0),
    },
}));
//# sourceMappingURL=styles.js.map